import React from "react";
import moment from "moment";

export default (data, user, edit, trash) => {

  return (
    <div className="mb-5 bg-off-white p-3 border-t border-grey md:flex">
      <div className="md:flex-grow">
        {data.author_is_group_user && data.viewable_by && data.viewable_by.length > 0 && !data.viewable_by.includes(user.id) ?

          <h3 className="mb-2">
            {data.title}
            <i className="fal fa-edit text-black ml-3" onClick={() => null}
               title={data.author_group ?  "To edit or delete, please contact the author " + data.author + " from the group " + data.author_group : 'To edit or delete, please contact the author or any Group Account Managers' }  />
          </h3>
          :
          <h3 className="mb-2" onClick={edit}>
            {data.title}
            <i className="fal fa-edit text-brand ml-3" onClick={edit} />
          </h3>
        }

        <footer>
          <p className="text-sm font-normal mb-0">
            {data.author}, {moment(data.created_at).format("MMM Do YYYY")}
          </p>
        </footer>
      </div>
      {data.author_is_group_user && data.viewable_by && data.viewable_by.length > 0 && !data.viewable_by.includes(user.id) ?
        <div className="self-end">
          <i className="fal fa-trash-alt text-black" onClick={() => null}
             title={data.author_group ?  "To edit or delete, please contact the author " + data.author + " from the group " + data.author_group : 'To edit or delete, please contact the author or any Group Account Managers' }  />
        </div>
        :
        <div className="self-end">
          <i className="fal fa-trash-alt text-warning" onClick={trash} />
        </div>
      }
    </div>
  );
}
